import { Color } from 'theme';

import { Dot, StyledSpinner } from './Spinner.styled';
import { Size } from './SpinnerTypes';

type Props = {
  size?: Size;
  label?: string;
  color?: Color | 'default';
};

export function Spinner({
  size = 'default',
  label = 'Loading',
  color = 'default',
}: Props) {
  return (
    <StyledSpinner $size={size} $color={color} aria-label={label}>
      <Dot />
    </StyledSpinner>
  );
}
